import {Pipe, PipeTransform} from '@angular/core';
import moment from "moment";

@Pipe({standalone: true, name: 'wmDateFormat'})
export class WmDateFormatPipe implements PipeTransform {
    transform(value: moment.MomentInput, ...args: any[]): string {
        if (!value) {
            return '';
        }
        return moment(value).format(args[0]);
    }
}
